import axios from "axios";
import React from "react";
import { _socketUrl } from "../../../config";
import { failed, success } from "../../../Utils/Alerts";

export default function Message() {
  const gonder = async () => {
    let message = document.getElementById("message").value;
    console.log(message);
    await axios.get(_socketUrl + "/socket/msg/" + message).then((res) => {
      if (res.data) {
        success("Mesaj Bildiriminiz Gönderilmiştir.");
      } else {
        failed("Mesaj gönderilemedi");
      }
    });
  };

  return (
    <div className="row">
      <div className="col-sm-9">
        <input
          style={{ height: "37.6px" }}
          className="form-control form-control-sm"
          id="message"
          placeholder="Uygulamaya gönderilecek bildirimi yazınız..."
          type={"text"}
        ></input>
      </div>
      <div className="col-sm-3">
        <button className="greenBtn" onClick={() => gonder()}>
          Gönder
        </button>
      </div>
    </div>
  );
}
